import api from '../api/slice';
import { ICampaignData, INewActionRewardCampaign, IActionRewardCampaign } from './type';

const actionRewardsApi = api.injectEndpoints({
  endpoints: builder => ({
    getActionRewards: builder.query<
      ICampaignData | IActionRewardCampaign,
      { appIds: string; page?: number; campaignId?: number; actionReward?: string }
    >({
      query: ({ appIds, page = 1, campaignId, actionReward }) => {
        // If campaignId is provided, fetch specific campaign without query params
        if (campaignId && campaignId > 0) {
          return {
            method: 'GET',
            url: `/action-reward/${campaignId}`,
          };
        }
        // Otherwise, fetch with filtering parameters for browsing across campaigns
        return {
          method: 'GET',
          url: `/action-reward?appIDs=${appIds}&page=${page}&actionReward=${actionReward}`,
        };
      },
      providesTags: ['actionRewards'],
    }),
    createActionRewardCampaigns: builder.mutation<any, { campaigns: INewActionRewardCampaign }>({
      query: ({ campaigns }) => ({
        url: `/action-reward`,
        method: 'POST',
        body: campaigns,
      }),
      invalidatesTags: ['actionRewards'],
    }),
    updateActionRewardCampaigns: builder.mutation<any, { campaigns: INewActionRewardCampaign; campaignId: number }>({
      query: ({ campaigns, campaignId }) => ({
        url: `/action-reward/${campaignId}`,
        method: 'PUT',
        body: campaigns,
      }),
      invalidatesTags: ['actionRewards'],
    }),
    deleteActionRewardCampaigns: builder.mutation<void, number>({
      query: campaignId => ({
        url: `/action-reward/${campaignId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['actionRewards'],
    }),
  }),
});

export const {
  useGetActionRewardsQuery,
  useLazyGetActionRewardsQuery,
  useCreateActionRewardCampaignsMutation,
  useUpdateActionRewardCampaignsMutation,
  useDeleteActionRewardCampaignsMutation,
} = actionRewardsApi;

export default actionRewardsApi;
